import * as types from './mutation-types.js'

const mutations = {
    [types.G_LOADING](state, payload) {
        state.isLoading = payload.isLoading
    },
    [types.G_DIRECTION](state, payload) {
        state.direction = payload.direction;
    },
    [types.G_USERINFO](state, payload) {
        state.userInfo = payload;
    },
    [types.G_INITIALIZE](state, payload) {
        state.initialize = payload;
    },
    [types.G_URL](state, payload) {
        state._url = payload;
    },
    [types.G_MENU](state, payload) {
        state._menu = payload;
    },
    [types.G_LEADER](state, payload) {
        state.leader = payload;
    },
    [types.G_LEADER_EMP](state, payload) {
        state.leader_emp = payload;
    },
    [types.G_DATA](state, payload) {
        state.data = payload;
    },
    [types.G_POSTCODE](state, payload) {
        state.postcode = payload;
    },
    [types.G_CARTNUM](state, payload) {
        if (payload !== undefined) {
            state.cartNum = payload;
        }
    },
    [types.G_MSGNUM](state, payload) {
        if (payload !== undefined) {
            state.msgNum = payload;
        }
    },
    [types.SET_COMMENT](state, payload) {
        state.comment = payload;
    },
    [types.SET_DEVICE](state, payload) {
        state.device = payload;
    },
    [types.SET_POSITION](state, payload) {
        state.position = payload;
    },[types.G_GUESTBOOKING](state, payload) {
        state.isGuest = payload
    },
}

export default mutations
